<div
	class="card-button-container"
	[@pressState]="buttonState"
	(click)="buttonClicked()"
	(mousedown)="onPress(true)"
	(mouseup)="onPress(false)"
	[style.background]="valid ? getGradient() : 'radial-gradient(circle at 73% 71%,#DA2370 ,#FB434A)'">
	<div
		class="card-button-base"
		[style.width]="width"
		[style.height]="height"
		[style.mix-blend-mode]="valid ? 'soft-light' : 'normal'"
		[style.background-color]="valid ? 'rgba(200, 200, 200, .7)' : 'initial'"></div>
	<div
		class="card-button-overlay-wrapper"
		[style.width]="width"
		[style.height]="height"
		[style.margin-top]="'-' + (margin_top ? margin_top : height)">
		<div
			class="card-button-overlay-base"
			(click)="buttonClicked()"
			[style.width]="overlayWidth"
			[style.height]="height"
			[style.mix-blend-mode]="valid ? 'soft-light' : 'normal'"
			[style.background]="!valid ? 'radial-gradient(circle at 73% 71%,#DA2370 ,#FB434A)' : 'rgba(200, 200, 200, .7)'"></div>
	</div>
	<ng-content></ng-content>
</div>
